import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/home/runner/work/learning-app-frontend/learning-app-frontend/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/learning-app-frontend/learning-app-frontend/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/runner/work/learning-app-frontend/learning-app-frontend/layouts/empty.vue").then(m => m.default || m))
}